import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeNavigationItemSkeleton } from './TypeNavigationItem'

export interface TypeNavigationItemGroupFields {
  title: EntryFieldTypes.Symbol
  items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNavigationItemSkeleton>>
}

export type TypeNavigationItemGroupSkeleton = EntrySkeletonType<TypeNavigationItemGroupFields, 'navigationItemGroup'>
export type TypeNavigationItemGroup<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypeNavigationItemGroupSkeleton,
  Modifiers,
  Locales
>

export function isTypeNavigationItemGroup<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeNavigationItemGroup<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'navigationItemGroup'
}
